import styled from 'styled-components';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const ButtonBanner = styled(Button)`
    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 100%;
    }
`;

export const PopupContent = styled.div`
    @media (max-width: ${wideBreakpoints.mobile}) {
        margin: 0 8px;
    }
`;

export const Paragraph = styled(Paragraph4)`
    margin-bottom: 16px;
    margin-left: 8px;
`;

export const TextBlock = styled.div`
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 8px;

    svg {
        max-width: 24px;
        width: 100%;

        #contour {
            > path {
                fill: ${COLORS.Brand_Blue};
            }
        }

        #guts {
            > path {
                fill: ${COLORS.BgMain};
            }
        }
    }
`;
